import { create } from "zustand";
import { getCookie } from "~/utils/cookies";

interface AuthState {
  isAuthExpired: boolean;
  setAuthExpired: (expired: boolean) => void;
  isImpersonating: boolean;
  setImpersonating: (impersonating: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthExpired: false,
  setAuthExpired: (expired: boolean) => set({ isAuthExpired: expired }),
  isImpersonating: getCookie("skyImpersonating") === "true",
  setImpersonating: (impersonating: boolean) =>
    set({ isImpersonating: impersonating }),
}));
